/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationTitleService } from 'app/layout/services/application-title.service';
import { OrderSearchListService } from 'app/modules/order/order-search/order-search/services/order-search-list.service';
import { FILTER_CONSUMER_REGISTER } from 'app/shared/components/filter-framework/filter-consumer-register';
import { FilterHeaderOptions, FilterPersistenceMode, FilterPersistenceOptions } from 'app/shared/components/filter-framework/filter-framework.models';

@Component({
	selector: 'customer-details',
	templateUrl: './customer-details.component.html',
	styleUrls: ['./customer-details.component.scss'],
	host: { class: 'orbit-list-page-host' },
	standalone: false,
})
export class CustomerDetailsComponent {
	basketCustomerId: number = 1;
	parentCollapsed = false;
	isOrganiserUser = false;
	readonly filterHeaderOptions: Partial<FilterHeaderOptions> = { mode: FILTER_CONSUMER_REGISTER.order.headerMode, showResultSummary: true };
	readonly filterPersistenceOptions: FilterPersistenceOptions = { enabled: false, mode: FilterPersistenceMode.None, storageKey: 'orbit.filters.customer-orders', schemaVersion: 1, persistExpandedState: false };

	customerId: number;
	constructor(public readonly service: OrderSearchListService, private route: ActivatedRoute, appTitleService: ApplicationTitleService) {
		appTitleService.setTitle('Customer Details');
		this.customerId = +route.snapshot.params['id'];
		this.service.setUnfilteredItemsCount(null);
	}

	onFilterChanged(filters: any) {
		// The CustomerId is a page scope rather than a user filter, so its count must not reuse
		// the global order-list total cached by the root-provided list service.
		this.service.setUnfilteredItemsCount(null);
		this.service.setFilters(filters);
	}
	onShowFiltersChanged() {
		this.parentCollapsed = !this.parentCollapsed;
	}
	setIsOrganiserUser(isOrganiserUser: boolean) {
		this.isOrganiserUser = isOrganiserUser;
	}
}
